export enum ConfigValueType {
  STRING = 'string',
  ARRAY = 'array',
  JSON = 'json'
}
